export default {
  Label_Common: {
    Dai_ChuShiHua: '待初始化',
    ZhengZai_ChuShiHua: '正在初始化',
    YiChang: '異常',
    ZhengChang_YingYe: '正常營業',
    TingZhi_YingYe: '停止營業',
    ZhenJiu_FanFa: '針灸方法',
    ZhenJiu_WeiZhi: '針灸位置',
    YaoPing_GongNeng: '藥品功能',
    YaoPing_PingPai: '藥品品牌',
    YaoPing_BiaoZhun: '藥品標準',
    HuiYuan_LeiBie: '會員類別',
    ChaKan: '查看',
    QiTa_ZhuMing: '其他 · 請註明',
    HuaYan_LeiXing: '化驗類型',
  },
}
